import { PlaqueOptions } from "./types";

export const PlaqueOptionKeys = {
  Color: "color",
  ColorEffect: "colorEffect",
  StrokeColor: "strokeColor",
  MarginLeft: "marginLeft",
  LogoWidth: "logoWidth",
  LogoPosY: "logoPosY",
  LogoColor: "logoColor",
  LogoColorEffect: "logoColorEffect",
  NameWidth: "nameWidth",
  NamePosY: "namePosY",
  NameMaxFontSize: "nameMaxFontSize",
  MembershipLevelWidth: "membershipLevelWidth",
  MembershipLevelPosY: "membershipLevelPosY",
  MembershipLevelMaxFontSize: "membershipLevelMaxFontSize",
  MembershipTypeWidth: "membershipTypeWidth",
  MembershipTypePosY: "membershipTypePosY",
  MembershipTypeMaxFontSize: "membershipTypeMaxFontSize",
  MembershipTypeColor: "membershipTypeColor",
  Transform: "transform",
  YearWidth: "yearWidth",
  YearPosY: "yearPosY",
  YearMaxFontSize: "yearMaxFontSize",
  SignatureWidth: "signatureWidth",
  SignaturePosY: "signaturePosY",
  CopyrightWidth: "copyrightWidth",
  CopyrightPosY: "copyrightPosY",
  ClippingMask: "clippingMask",
  SeparateDesignationFromName: "separateDesignationFromName",
  NameFont: "nameFont",
  NameFontStyle: "nameFontStyle",
  NameFontWeight: "nameFontWeight",
  NameFontColor: "nameFontColor",
  DesignationFont: "designationFont",
  DesignationFontWeight: "designationFontWeight",
  DesignationYOffset: "designationYOffset",
  DesignationXOffset: "designationXOffset",
  DesignationPosY: "designationPosY",
  DesignationWidth: "designationWidth",
  DesignationMaxFontSize: "designationMaxFontSize",
  DesignationFontStyle: "designationFontStyle",
  MembershipLevelFont: "membershipLevelFont",
  MembershipLevelFontStyle: "membershipLevelFontStyle",
  MembershipLevelFontWeight: "membershipLevelFontWeight",
  MembershipTypeFont: "membershipTypeFont",
  MembershipTypeFontStyle: "membershipTypeFontStyle",
  MembershipTypeFontWeight: "membershipTypeFontWeight",
  YearFont: "yearFont",
  YearFontStyle: "yearFontStyle",
  YearFontWeight: "yearFontWeight",
  LogoYOffset: "logoYOffset",
  NameYOffset: "nameYOffset",
  LogoXOffset: "logoXOffset",
  NameXOffset: "nameXOffset",
  MembershipLevelXOffset: "membershipLevelXOffset",
  MembershipTypeXOffset: "membershipTypeXOffset",
  YearYOffset: "yearYOffset",
  SignatureXOffset: "signatureXOffset",
  PhotoWidth: "photoWidth",
  PhotoPosY: "photoPosY",
  PhotoPosX: "photoPosX",
  YearInsertPositions: "yearInsertPositions",
  YearInsertPlateHeight: "yearInsertPlateHeight",
  YearInsertPlateWidth: "yearInsertPlateWidth",
  YearInsertTextOffset: "yearInsertTextOffset",
  YearInsertPlateColor: "yearInsertPlateColor",
  DividerWidth: "dividerWidth",
  DividerPosY: "dividerPosY",
  DividerYOffset: "dividerYOffset",
  NoSeparateDesignationOffset: "noSeparateDesignationOffset",
} as const satisfies Record<string, keyof PlaqueOptions>;
